import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-file-upload-caption',
  templateUrl: './file-upload-caption.component.html',
  styleUrls: ['./file-upload-caption.component.scss']
})
export class FileUploadCaptionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
